/**
 * Created by andreyna on 6/13/2016.
 */
import BaseModelComponent from '../../base/base_model_component';
import { ILocalizedGameInfo } from '../../services/games_information/games_information_service_interface';
import FPGamesComponentController from '../free_play/games/fp_games_component_controller';

export interface IButtonInfo {
    textKey: string;
    classList: string[];
    onClick: () => void;
}

export default class GameItemComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameItemComponentModel';
    private _gameInfo: ILocalizedGameInfo;
    private _containerRef: FPGamesComponentController;
    private _onClickFn: Function;
    private _fpType: string;
    private _itemClass: string;
    private _playBtnText: string;
    private _buttons: IButtonInfo[];
    private _show: boolean;
    private _jackpotRef: any;


    /**
     *
     * @param params
     */
    init(params: any = {}) {
        super.init(params);
        this
            .setShow(params.show)
            ._setGame(params.gameData)
            ._setOnClickHandler(params.onClicked)
            ._setFPType(params.fpType)
            ._setItemClass(params.itemClass)
            ._setPlayBtnText(params.playBtnText)
            ._setButtons(params.buttons)
            ._setContainerRef(params.container);
    }

    setShow(show = true) {
        this._show = show;
        return this;
    }

    /**
     * Set voucher game data
     * @param game
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setGame(gameData) {
        this._gameInfo = gameData;
        return this;
    }


    /**
     * Set reference for games container object
     * @param container
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setContainerRef(container) {
        this._containerRef = container;
        return this;
    }


    /**
     * Set handle function for game item click event
     * @param onClicked
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setOnClickHandler(onClicked) {
        this._onClickFn = onClicked;
        return this;
    }


    /**
     * Set FreePlay type
     * @param fpThumb
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setFPType(fpType) {
        this._fpType = fpType;
        return this;
    }


    /**
     * Set Game item container class
     * @param itemClass
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setItemClass(itemClass) {
        this._itemClass = itemClass;
        return this;
    }


    /**
     * Set text for Play button
     * @param playBtnText
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setPlayBtnText(playBtnText = 'game_item_play_btn') {
        this._playBtnText = playBtnText;
        return this;
    }


    /**
     * Set custom buttons
     * @param buttons
     * @returns {GameItemComponentModel}
     * @private
     */
    private _setButtons(buttons) {
        this._buttons = buttons;
        return this;
    }


    getShow() {
        return this._show;
    }


    /**
     * Get game data
     * @returns {*}
     */
    getGame() {
        return this._gameInfo;
    }


    /**
     * Set reference to jackpot component
     * @param jackpotRef
     * @returns {GameItemComponentModel}
     */
    setJackpotRef(jackpotRef) {
        this._jackpotRef = jackpotRef;
        return this;
    }


    /**
     *
     */
    getContainerRef() {
        return this._containerRef;
    }


    /**
     * Get handler function for game click event
     * @returns {*}
     */
    getOnClickHandler() {
        return this._onClickFn;
    }


    /**
     *
     * @returns {*}
     */
    getFPType() {
        return this._fpType;
    }


    /**
     * Return game item container custom class
     * @param itemClass
     * @returns {*}
     */
    getItemClass() {
        return this._itemClass;
    }


    /**
     * Get play button text
     * @returns {*}
     */
    getPlayBtnText() {
        return this._playBtnText;
    }


    /**
     * Get custom buttons options
     * @returns {*}
     */
    getButtons() {
        return this._buttons;
    }
}
